import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../styles/Navbar.css";

const NavbarComp = () => (
  <Navbar  variant="" expand="lg" style={{ background: '#fff' }}>
    <Container>
        <Nav.Link as={Link} to="/"><h2>StopTheBus</h2></Nav.Link>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar">
        <Nav className="ms-auto">
        
        <div className="first-button">
        <Nav.Link as={Link} to="/">Home</Nav.Link>
        </div>
        <div class="space">
        </div>
        <div className="second-button">
        <Nav.Link as={Link} to="/Bus">Times</Nav.Link>
        </div>

        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>
);

export default NavbarComp;